import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { doc, addDoc, collection, updateDoc } from 'firebase/firestore';
import './ManageOffers.css';

const AddOffer = ({ 
  coffeeShopId, 
  coffeeShopName, 
  onSuccess, 
  editData,
  onCancelEdit 
}) => {
  const [title, setTitle] = useState(editData?.title || '');
  const [threshold, setThreshold] = useState(editData?.threshold || '');
  const [reward, setReward] = useState(editData?.reward || '');
  const [active, setActive] = useState(editData?.active ?? true);
  const [offerDescription, setOfferDescription] = useState(editData?.description || '');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const trimmedTitle = title.trim();
    const trimmedDescription = offerDescription.trim();

    if (!trimmedTitle || !threshold || !reward || !trimmedDescription) {
      setMessage('❌ All fields are required');
      setIsSubmitting(false);
      return;
    }

    try {
      const offerData = {
        title: trimmedTitle,
        description: trimmedDescription,
        threshold: Number(threshold),
        reward: Number(reward),
        active,
        coffee_shop_id: coffeeShopId,
        coffee_shop_name: coffeeShopName,
        createdAt: new Date(),
      };

      if (editData) {
        await updateDoc(doc(db, 'offers', editData.id), {
          ...offerData,
          updatedAt: new Date(),
        });
        setMessage('✏️ Offer updated successfully!');
      } else {
        await addDoc(collection(db, 'offers'), offerData);
        setMessage('✅ Offer added successfully!');
      }

      if (!editData) {
        setTitle('');
        setThreshold('');
        setReward('');
        setOfferDescription('');
        setActive(true);
      }

      if (onSuccess) onSuccess();
      
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-card">
        <h2>{editData ? 'Edit Offer' : 'Create New Offer'}</h2>
        {message && (
          <div className={`notification ${message.includes('❌') ? 'error' : 'success'}`}>
            {message}
          </div>
        )}
        <form className="offer-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label htmlFor="title">Offer Title</label>
            <input
              id="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. Buy 1 Get 1 Free"
            />
          </div>

          <div className="form-row">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              value={offerDescription}
              onChange={(e) => setOfferDescription(e.target.value)}
              placeholder="Offer details..."
            />
          </div>

          <div className="form-row">
            <label htmlFor="threshold">Threshold</label>
            <input
              id="threshold"
              type="number"
              value={threshold}
              onChange={(e) => setThreshold(e.target.value)}
              placeholder="e.g. 5 (number of purchases needed)"
              min="1"
            />
          </div>

          <div className="form-row">
            <label htmlFor="reward">Reward</label>
            <input
              id="reward"
              type="number"
              value={reward}
              onChange={(e) => setReward(e.target.value)}
              placeholder="e.g. 1 (free coffee)"
              min="1"
            />
          </div>

          <div className="form-row">
            <label>
              <input
                type="checkbox"
                checked={active}
                onChange={() => setActive(!active)}
              />
              <span> Active Offer</span>
            </label>
          </div>

          <div className="form-actions">
            {editData && (
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onCancelEdit}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            )}
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Processing...' : editData ? 'Update Offer' : 'Add Offer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOffer;